import { t as tr } from './i18n.js'
import { useState } from 'react'
import { Check } from 'lucide-react'

/**
 * Clipboard with a fallback that works over plain http on a LAN (the async
 * Clipboard API is only available in secure contexts), plus visible feedback.
 */
export async function copyText(text: string): Promise<boolean> {
  try { if (navigator.clipboard && window.isSecureContext) { await navigator.clipboard.writeText(text); return true } } catch { /* fall through */ }
  try {
    const ta = document.createElement('textarea')
    ta.value = text; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.top = '-1000px'
    document.body.appendChild(ta); ta.select(); ta.setSelectionRange(0, text.length)
    const ok = document.execCommand('copy')
    document.body.removeChild(ta)
    return ok
  } catch { return false }
}

export function CopyButton({ text, label = 'Copy', tip = 'Copy to clipboard', className = 'button' }: { text: string; label?: string; tip?: string; className?: string }) {
  const [state, setState] = useState<'idle' | 'ok' | 'fail'>('idle')
  return (
    <button type="button" className={className} data-tip={tip} onClick={async () => { const ok = await copyText(text); setState(ok ? 'ok' : 'fail'); setTimeout(() => setState('idle'), 1800) }}>
      {state === 'ok' ? <><Check size={14} strokeWidth={2} aria-hidden /> {tr("Copied")}</> : state === 'fail' ? 'Select & copy manually' : label}
    </button>
  )
}
